import React from 'react';
      const Test = ({ props }) => {
  return (
    <>
    <h1 className="Test">
       Test 
    </h1>
    <a href='/Home'>Home</a>
    </>
    )
  };
  export default Test;

